"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var entities_1 = require("../entities");
/**
 * @hidden
 */


exports.createReclaimFundsResolver = function (dividendIndex, factories, symbol) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", factories.dividendDistributionFactory.refresh(entities_1.DividendDistribution.generateId({
                securityTokenId: entities_1.SecurityToken.generateId({
                  symbol: symbol
                }),
                index: dividendIndex
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
/**
 * Procedure that allows the issuer to reclaim dividends after they expire without being claimed by tokenholders
 */


var ReclaimFunds =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(ReclaimFunds, _Procedure_1$Procedur);

  function ReclaimFunds() {
    var _this2;

    _classCallCheck(this, ReclaimFunds);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ReclaimFunds).apply(this, arguments));
    _this2.type = types_1.ProcedureType.ReclaimFunds;
    return _this2;
  }
  /**
   * Reclaim funds
   *
   * Note that this procedure will fail if:
   * - The Security Token doesn't exist
   * - The Dividends Feature hasn't been enabled
   */


  _createClass(ReclaimFunds, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this$args, symbol, dividendIndex, _this$context, contractWrappers, factories, _ref, _ref2, dividendModule;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$args = this.args, symbol = _this$args.symbol, dividendIndex = _this$args.dividendIndex;
                _this$context = this.context, contractWrappers = _this$context.contractWrappers, factories = _this$context.factories;
                _context2.prev = 2;
                _context2.next = 5;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 10:
                _context2.next = 12;
                return contractWrappers.getAttachedModules({
                  symbol: symbol,
                  moduleName: contract_wrappers_1.ModuleName.ERC20DividendCheckpoint
                }, {
                  unarchived: true
                });

              case 12:
                _ref = _context2.sent;
                _ref2 = _slicedToArray(_ref, 1);
                dividendModule = _ref2[0];

                if (dividendModule) {
                  _context2.next = 17;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "The Dividends Feature hasn't been enabled"
                });

              case 17:
                _context2.next = 19;
                return this.addTransaction(dividendModule.reclaimDividend, {
                  tag: types_1.PolyTransactionTag.ReclaimDividendFunds,
                  resolvers: [exports.createReclaimFundsResolver(dividendIndex, factories, symbol)]
                })({
                  dividendIndex: dividendIndex
                });

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 7]]);
      }));
    }
  }]);

  return ReclaimFunds;
}(Procedure_1.Procedure);

exports.ReclaimFunds = ReclaimFunds;